import { NETWORK_METADATA_MAP } from "../../../utils/networkConstants";
// We re-export with the same name for compatibility, adding aliases for GA/GAds/etc if needed
export const NETWORK_ICON_MAP = {
    ...NETWORK_METADATA_MAP,
    // Add specific aliases used in this module if they differ from standard names
    "google-analytics": NETWORK_METADATA_MAP.ga,
    "ga": NETWORK_METADATA_MAP.ga,
    "Rakuten (Linkshare)": NETWORK_METADATA_MAP.rakuten,
    "Google Analytics": NETWORK_METADATA_MAP.ga,
    "Google Ads": NETWORK_METADATA_MAP.adword,
    "Facebook Ads": NETWORK_METADATA_MAP.meta,
    "Bing Ads": NETWORK_METADATA_MAP.bing,
    "commision_factory": NETWORK_METADATA_MAP.commission_factory, // typo alias
};
export const STATUS_MAP = {
    completed: "Completed",
    not_found: "Completed",
    pending: "In process",
    in_progress: "In process",
    failed: "Failed",
};
export const tableContainerSx = {
    border: "1px solid #EAECF0", borderRadius: "12px", overflow: "hidden",
    "& table": { borderCollapse: "separate", borderSpacing: 0 },
    "& th, & td": { borderRight: "1px solid #EAECF0", borderBottom: "1px solid #EAECF0" },
    "& tr > :first-of-type": { borderLeft: "1px solid #EAECF0" },
    "& thead tr:first-of-type th": { borderTop: "1px solid #EAECF0" },
    "& thead th, & thead tr:nth-of-type(1) th, & thead tr:nth-of-type(2) th": { background: "#F9FAFB", position: "sticky", zIndex: 6 },
    "& thead tr:nth-of-type(2) th": { top: "45px", zIndex: 5 },
    "& tfoot td, & tfoot th": { backgroundColor: "#F9FAFB", fontWeight: 600 },
};
